import React from 'react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  onClick?: () => void;
  className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description, onClick, className }) => {
  return (
    <article 
      className={`p-6 rounded-xl border border-[var(--brand-primary)]/20 bg-[var(--brand-primary)]/20 hover:border-[var(--brand-primary)]/40 transition-all duration-300 cursor-pointer ${className || ''}`}
      onClick={onClick}
    >
      <div className="mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-[var(--text-primary)] mb-2">{title}</h3>
      <p className="text-[var(--text-tertiary)]">{description}</p>
    </article>
  );
};

export default FeatureCard;